module.exports = __webpack_public_path__ + "img/client1.93b51779.png";